
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg","data-token-name":"conversation"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.422 5.623a7.584 7.584 0 10-13.57 6.575L.625 16.875l4.677-2.227a7.566 7.566 0 002.823 1.053","stroke":"currentColor","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M14.902 8.75a4.453 4.453 0 013.355 7.405l.559 3.22-2.917-1.798a4.47 4.47 0 11-1-8.827h.003z","stroke":"currentColor","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    